import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const BiometricsIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        d="M16.6,12.7l-3.4,7.9L10.9,7.8l-2.8,4.8H2C2.3,17.8,6.7,22,12,22c5.3,0,9.6-4.1,10-9.3H16.6z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M7.3,11.2l4.3-7.4l2.1,12l2-4.5H22C21.6,6.1,17.3,2,12,2C6.7,2,2.4,6.1,2,11.2H7.3z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </IconBase>
  );
};

export default BiometricsIcon;
